const MediaQueries = {
  TABLET: '@media (min-width: 768px)',
  DESKTOP: '@media (min-width: 1024px)',
  BIG_DESKTOP: '@media (min-width: 1240px)',
};

export default MediaQueries;
